"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Loops over each item of a sequence.
 *
 * <pre>
 * <ul>
 *  {% for user in users %}
 *    <li>{{ user.username|e }}</li>
 *  {% endfor %}
 * </ul>
 * </pre>
 */
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const spaceless_1 = require("../node/spaceless");
class TwingTokenParserSpaceless extends token_parser_1.TwingTokenParser {
    parse(token) {
        console.error('The "spaceless" tag is deprecated since Twig 2.7, use the "spaceless" filter instead.');
        let lineno = token.getLine();
        let columnno = token.getColumn();
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        let body = this.parser.subparse([this, this.decideSpacelessEnd], true);
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new spaceless_1.TwingNodeSpaceless(body, lineno, columnno, this.getTag());
    }
    decideSpacelessEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endspaceless');
    }
    getTag() {
        return 'spaceless';
    }
}
exports.TwingTokenParserSpaceless = TwingTokenParserSpaceless;
